"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const utils_1 = require("data/transactions/utils");
const index_1 = __importStar(require("components/QuickenControls/AmountField/index"));
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const TxnRowAmountField = ({ attributes, callbacks, editable, SHOW_ALL, txn, editClass, hoverClass, bankPendingClass, field, fieldIsEditable, currEditFieldName, currencySymbol, enableAutoFocus, amountProposedSign, focusField, }) => {
    var _a, _b;
    const { classes, theme } = useStyles();
    const c2RTxnClass = (0, utils_1.isC2RTransaction)(txn) ? classes.txnInC2RText : '';
    return (<styles_1.RegListItem {...attributes} className={(0, classnames_1.default)('amount', classes.regItem, 'protectWidth', editClass, hoverClass, bankPendingClass, c2RTxnClass)}>
      {SHOW_ALL &&
            <index_1.default 
            // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
            disableUnderline={(_a = theme.components) === null || _a === void 0 ? void 0 : _a.register.noUnderline} clickable={fieldIsEditable(field) ? 'true' : null} thinFont 
            // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
            fontSize={(_b = theme.components) === null || _b === void 0 ? void 0 : _b.register.fontSize.default} amountType="amount" proposedSign={amountProposedSign} lockInitialProposedSign 
            // @ts-expect-error: The expected type comes from property 'onChange' which is declared here on type 'IntrinsicAttributes & AmountFieldProps'
            onChange={callbacks.handleChange} onBlur={(e, fieldType, wasEnter) => {
                    var _a;
                    (_a = callbacks.onAmountBlur) === null || _a === void 0 ? void 0 : _a.call(callbacks, e, field, wasEnter);
                }} editable={fieldIsEditable(field) && editable && currEditFieldName === 'amount'} autoFocus={enableAutoFocus} 
            // @ts-expect-error: Type 'string' is not assignable to type 'number'.
            value={String(txn.amount)} className={(0, classnames_1.default)(classes.regInput, 'amount')} currencySymbol={currencySymbol} 
            // @ts-expect-error: null is not assignable to type
            inputRef={fieldIsEditable(field) && editable && currEditFieldName === 'amount' ?
                    (input) => {
                        focusField.current = input; // eslint-disable-line
                    } : null} showSign={index_1.ShowSignEnum.NEGATIVE_ONLY} showColor={index_1.ShowColorEnum.POSITIVE_ONLY}>
      </index_1.default>}
    </styles_1.RegListItem>);
};
exports.default = TxnRowAmountField;
